module.exports = __webpack_public_path__ + "static/gosugam-casestudy-img-b1534291cbc7fa258e506946f157d3fb.jpeg";